<template>
  <div class="context">
    <div class="container">
      <keep-alive v-bind:include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/pages/layout/Footer";

export default {
  name: "Context",
  computed: {
    cachedViews() {
      return this.$route.fullPath;
    },
    key() {
      return this.$route.fullPath;
    }
  },
  components: { Footer }
};
</script>
<style lang="scss" scoped>
@import "../../styles/transition.scss";
</style>
<style lang="sass" scoped>
.context
  height: calc(100% - 60px)
  width: 100%
  padding-top: 5px
  box-sizing: border-box
  overflow: auto
  .container
    // padding: 20px
    box-sizing: border-box
</style>



// WEBPACK FOOTER //
// src/pages/layout/Context.vue